'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('../css/DateField.css');

require('../css/ControlBase.css');

var _DatePicker = require('./DatePicker');

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _utilsLib = require('utils-lib');

var _MessageBox = require('./MessageBox');

var _MessageBox2 = _interopRequireDefault(_MessageBox);

var _Vas = require('../../build/Vas');

var _Vas2 = _interopRequireDefault(_Vas);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var moment = require('moment');
moment().format();

/*
Pflichtproperties:
me={this} Editable={true/false} IsRequired={true/false}
ref={"dateOfBirth"} Id={"DateOfBirth"} 
Tooltip={Vas.Resources.Tooltips["DateOfBirth"]} Label={ Vas.Resources.Labels["DateOfBirth"]} 
AppURL={Vas.ApplicationUrl}
PickerFormatText={Vas.Resources.Labels["PickerFormat"]}
ChooseDataText={Vas.Resources.Labels["ChooseDate"]} TooltipMonth={Vas.Resources.Tooltips["Month"]} TooltipYear={Vas.Resources.Tooltips["Year"]}
CalenderText={[Vas.Resources.Calendar["January"] ,Vas.Resources.Calendar["February"] ,Vas.Resources.Calendar["March"] ,Vas.Resources.Calendar["April"] ,Vas.Resources.Calendar["May"] ,
    Vas.Resources.Calendar["June"] ,Vas.Resources.Calendar["July"] ,Vas.Resources.Calendar["August"] ,Vas.Resources.Calendar["September"] ,Vas.Resources.Calendar["October"] ,
    Vas.Resources.Calendar["November"] ,Vas.Resources.Calendar["December"] ]} 
CalenderWeekDayText={[ Vas.Resources.Calendar["CW"],Vas.Resources.Calendar["Monday"] ,Vas.Resources.Calendar["Tuesday"],Vas.Resources.Calendar["Wednesday"],
    Vas.Resources.Calendar["Thursday"],Vas.Resources.Calendar["Friday"],Vas.Resources.Calendar["Saturday"],Vas.Resources.Calendar["Sunday"]]}
Language={localStorage.getItem("vas_language")}

optional:
MaxValue={moment()} MinValue={moment()} First={true/false} Last={true/false}
OnBlur={()=>{this.setState( { DateOfBirth:  $("#DateOfBirth").val()})}}  
*/

var DateField = function (_Component) {
    _inherits(DateField, _Component);

    function DateField(props) {
        _classCallCheck(this, DateField);

        var _this = _possibleConstructorReturn(this, (DateField.__proto__ || Object.getPrototypeOf(DateField)).call(this, props));

        _this.state = {};
        _this.state.PickerActive = false;
        _this.state.IsValid = true;
        _this.state.Label = _this.props.Label;
        _this.state.Value = _this.props.Value;
        _this.state.Placeholder = _this.props.Placeholder;
        _this.state.MinValue = _this.props.MinValue;
        _this.state.MaxValue = _this.props.MaxValue;
        _this.state.isrequired = _this.props.IsRequired;
        _this.state.ShowDay = _this.props.ShowDay !== null && _this.props.ShowDay !== undefined ? _this.props.ShowDay : true;
        _this.state.MaxYearsInFuture = _this.props.MaxYearsInFuture;
        _this.state.FalseMinDateText = _this.props.FalseMinDateText ? _this.props.FalseMinDateText : _Vas2.default.getText('Labels', 'PreMinDate');
        _this.state.FalseMaxDateText = _this.props.FalseMaxDateText ? _this.props.FalseMaxDateText : _Vas2.default.getText('Labels', 'PostMaxDate');

        return _this;
    }

    //#region springe weiter und Validiere Datum


    _createClass(DateField, [{
        key: 'tab',
        value: function tab(event, me) {
            //event tab oder enter
            if (event) {
                var docs = document.querySelectorAll(' div.ss-selected-option,input,div.extendedButton,select,button');
                var maxId = docs.length;
                var aktive = document.activeElement.id;
                me.setState({ KeyCode: event.keyCode });
                if (event.keyCode === 13 || event.keyCode === 9) {
                    me.checkFields(me);
                    me.validateDate(me);
                    var i = void 0;
                    for (i = 0; i <= maxId - 1; i++) {
                        if (docs[i].id === aktive) {
                            if (i === maxId - 1) {
                                docs[i].blur();
                                break;
                            } else {
                                if (event.shiftKey && event.keyCode === 9) {
                                    for (var j = i - 1; j >= 0; j--) {
                                        if (!docs[j].readOnly) {
                                            docs[j].focus();
                                            break;
                                        } else if (docs[j].className === "ss-selected-option") {
                                            var _event = new Event("click");
                                            docs[j].dispatchEvent(_event);
                                            break;
                                        }
                                    }
                                } else {
                                    for (var _j = i + 1; _j <= maxId - 1; _j++) {
                                        if (!docs[_j].readOnly) {
                                            docs[_j].focus();
                                            break;
                                        } else if (docs[_j].className === "ss-selected-option") {
                                            var _event2 = new Event("click");
                                            docs[_j].dispatchEvent(_event2);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            } else {
                me.ClosePicker(me);
            }
        }
    }, {
        key: 'checkFields',
        value: function checkFields(me) {
            if (me.props.me) {
                var docs = document.querySelectorAll('select,input');
                var docRefs = me.props.me.refs;
                _utilsLib.CheckValues.checkAllFields(docs, docRefs, me.props.Id);
            }
        }
    }, {
        key: 'getPickerMinMax',
        value: function getPickerMinMax(me) {
            var pickerMinMax = ''; // -> 4 Zeichen "MinValue, MaxValue, First, Last" 0=false, 1= true
            if (me.state.MinValue) {
                pickerMinMax += '1';
            } else {
                pickerMinMax += '0';
            }
            if (me.state.MaxValue) {
                pickerMinMax += '1';
            } else {
                pickerMinMax += '0';
            }
            return pickerMinMax;
        }
    }, {
        key: 'getPickerFirstLast',
        value: function getPickerFirstLast(me) {
            var pickerFirstLast = '';
            if (me.props.First) {
                pickerFirstLast += '1';
            } else {
                pickerFirstLast += '0';
            }

            if (me.props.Last) {
                pickerFirstLast += '1';
            } else {
                pickerFirstLast += '0';
            }
            return pickerFirstLast;
        }
    }, {
        key: 'FirstLastHelper',
        value: function FirstLastHelper(xDate, me) {
            var valid = true;
            var newDate = moment(xDate, 'DD-MM-YYYY', true);
            if (xDate._i.length >= 6) {
                var length = xDate._i.substring(_utilsLib.DateTimeHelper.getAllIndexes(xDate._i, '/')[1] + 1, xDate._i.length).length;
                if (length === 4 || length === 2) {
                    switch (me.getPickerFirstLast(me)) {
                        case '01':
                            {
                                if (xDate.date() < _utilsLib.DateTimeHelper.GetLastDayOfMonth(xDate.month(), xDate.year())) {
                                    valid = false;
                                } else {
                                    valid = newDate.isValid();
                                    newDate = xDate;
                                }
                                break;
                            }
                        case '10':
                            {
                                if (xDate.date() > 1) {
                                    valid = false;
                                } else {
                                    valid = newDate.isValid();
                                    newDate = xDate;
                                }
                                break;
                            }
                        case '11':
                            {
                                if (xDate.date() > 1 && xDate.date() < _utilsLib.DateTimeHelper.GetLastDayOfMonth(xDate.month(), xDate.year())) {
                                    valid = false;
                                } else {
                                    valid = newDate.isValid();
                                    newDate = xDate;
                                }
                                break;
                            }
                        default:
                            {
                                newDate = xDate;
                                break;
                            }
                    }
                } else {
                    valid = false;
                }
            } else {
                valid = false;
            }
            return [valid, newDate];
        }
    }, {
        key: 'validateDate',
        value: function validateDate(me, e) {
            var _this2 = this;

            // validiere das eingegebene Datum, ob zulässig (in Bezug auf vorgegebene Datumsgrenzen)
            var valid = false;
            var newDate = moment();
            var goOn = true;
            var date = (0, _jquery2.default)("#" + me.props.Id).val().trim(); //lösche alle abschließenden Leerzeichen

            if (date.length === 0) {
                date = (0, _jquery2.default)("#" + me.props.Id).attr('placeholder');
                date = _utilsLib.DateTimeHelper.StringToDate(date, false, me.props.Language);
                if (date.isValid() === false) {
                    date = '';
                    goOn = false;
                } else {
                    date = _utilsLib.DateTimeHelper.FormatToShortDateString(date);
                }
            }

            if (this.state.ShowDay === false) {
                var curDate = _utilsLib.DateTimeHelper.StringToDate(date, false, me.props.Language, this.state.ShowDay);
                curDate.date(_utilsLib.DateTimeHelper.GetLastDayOfMonth(curDate.month(), curDate.year()));
                date = _utilsLib.DateTimeHelper.FormatToShortDateString(curDate);
            }

            if (goOn === true) {
                var beforeMin = false;
                var afterMax = false;
                var formate = true;
                if (date.length > 0) {
                    if (typeof date !== 'undefined') {
                        valid = _utilsLib.CheckDate.Check(date, localStorage.getItem("vas_language"));
                        if (valid === true) {
                            var xDate = _utilsLib.DateTimeHelper.StringToDate(date, false, me.props.Language);
                            switch (me.getPickerMinMax(me)) {
                                case '00':
                                    {
                                        //Nicht Min und Nicht MAx
                                        var result = me.FirstLastHelper(xDate, me);
                                        valid = result[0];
                                        newDate = result[1];
                                        break;
                                    }
                                case '01':
                                    {
                                        //Nicht Min und Max
                                        if (xDate.isAfter(moment(me.state.MaxValue), 'day')) {
                                            afterMax = true;
                                            valid = false;
                                        } else {
                                            var _result = me.FirstLastHelper(xDate, me);
                                            valid = _result[0];
                                            newDate = _result[1];
                                        }
                                        break;
                                    }
                                case '10':
                                    {
                                        //Min und NICHT Max
                                        if (xDate.isBefore(moment(me.state.MinValue), 'day')) {
                                            valid = false;
                                            beforeMin = true;
                                        } else {
                                            var _result2 = me.FirstLastHelper(xDate, me);
                                            valid = _result2[0];
                                            newDate = _result2[1];
                                        }
                                        break;
                                    }
                                case '11':
                                    {
                                        //Min und Max

                                        if (xDate.isBetween(moment(me.state.MinValue), moment(me.state.MaxValue), 'day', []) === true) {
                                            var _result3 = me.FirstLastHelper(xDate, me);
                                            valid = _result3[0];
                                            newDate = _result3[1];
                                        } else {
                                            valid = false;
                                            if (xDate.isAfter(moment(me.state.MaxValue))) {
                                                afterMax = true;
                                            } else if (xDate.isBefore(moment(me.state.MinValue))) {
                                                beforeMin = true;
                                            }
                                        }
                                        break;
                                    }
                                default:
                                    break;
                            }
                        } else {
                            var cur = _utilsLib.DateTimeHelper.StringToDate(date, false, me.props.Language);
                            if (cur.year() > 2099 || cur.year() < 1900) {
                                formate = true;
                            } else {
                                formate = false;
                            }
                        }
                    }
                }

                if (valid === false) {
                    me.setState({ IsValid: false }, function () {
                        if (_this2.state.Placeholder) {
                            (0, _jquery2.default)("#" + me.props.Id).val(_this2.state.Placeholder);
                        } else {
                            (0, _jquery2.default)("#" + me.props.Id).val('');
                        }

                        if (beforeMin === true) {

                            _reactDom2.default.render(_react2.default.createElement(_MessageBox2.default, {
                                Message: me.state.FalseMinDateText,
                                Title: me.props.FalseDateTitle ? me.props.FalseDateTitle : _Vas2.default.getText("Titles", "Note"),
                                Field: me.props.Id
                            }), document.getElementById('messageContainer'));
                        } else if (afterMax === true) {

                            _reactDom2.default.render(_react2.default.createElement(_MessageBox2.default, {
                                Message: me.state.FalseMaxDateText,
                                Title: me.props.FalseDateTitle ? me.props.FalseDateTitle : _Vas2.default.getText("Titles", "Note"),
                                Field: me.props.Id
                            }), document.getElementById('messageContainer'));
                        } else {
                            if (formate === true) {

                                _this2.validateDate(_this2, e);
                                if (_this2.props.OnBlur) {
                                    _this2.props.OnBlur();
                                }

                                _reactDom2.default.render(_react2.default.createElement(_MessageBox2.default, {
                                    Message: me.props.FalseDateText ? me.props.FalseDateText : _Vas2.default.getText('Labels', 'DateNotValid'),
                                    Title: me.props.FalseDateTitle ? me.props.FalseDateTitle : _Vas2.default.getText("Titles", "Note"),
                                    Field: me.props.Id
                                }), document.getElementById('messageContainer'));
                            } else {

                                _reactDom2.default.render(_react2.default.createElement(_MessageBox2.default, {
                                    Message: _Vas2.default.getText('Labels', 'DateFalseFormat'),
                                    Title: me.props.FalseDateTitle ? me.props.FalseDateTitle : _Vas2.default.getText("Titles", "Note"),
                                    Field: me.props.Id
                                }), document.getElementById('messageContainer'));
                            }
                        }
                    });
                } else if (valid === true) {
                    if (newDate.isValid() === true) {
                        me.setState({ IsValid: true }, function () {
                            (0, _jquery2.default)("#" + me.props.Id).val(_utilsLib.DateTimeHelper.FormatToShortDateString(newDate, _this2.state.ShowDay));
                        });
                    } else {
                        me.setState({ IsValid: false }, function () {
                            (0, _jquery2.default)("#" + me.props.Id).val('');
                        });
                    }
                }
            }
        }
    }, {
        key: 'setDateText',
        value: function setDateText(me, text) {
            var last = text.substring(text.length - 1, text.length);
            var arr = last.match(/[./]/gi);
            if (!arr) {
                switch (localStorage.getItem('vas_language')) {
                    case 'de':
                        {
                            (0, _jquery2.default)("#" + me.props.Id).val(text + ".");
                            break;
                        }
                    case 'en':
                        {
                            (0, _jquery2.default)("#" + me.props.Id).val(text + "/");
                            break;
                        }
                    default:
                        break;
                }
            }
        }
    }, {
        key: 'ongoingText',
        value: function ongoingText(me) {
            me.ClosePicker(me);

            var text = (0, _jquery2.default)("#" + me.props.Id).val();
            var arr = text.match(/[0-9./]/gi); //erlaubte Zeichen
            if (arr) {
                if (arr.length > 0) {
                    if (arr.length === text.length) {
                        if (this.state.ShowDay === false) {
                            if (text.length === 2 || text.length === 4 || text.length === 5) {
                                if (me.state.KeyCode) {
                                    if (me.state.KeyCode === 8) {
                                        (0, _jquery2.default)("#" + me.props.Id).val(text);
                                    } else {
                                        // eslint-disable-next-line default-case
                                        switch (text.length) {
                                            case 2:
                                                {
                                                    me.setDateText(me, text);
                                                    break;
                                                }
                                            default:
                                                break;
                                        }
                                    }
                                }
                            }
                            if (text.length >= 3 && text.length <= 7) {
                                var last = text.substring(text.length - 1, text.length);
                                var prelast = text.substr(text.length - 2, 1);
                                if (last === prelast && (last === "." || last === "/")) {
                                    (0, _jquery2.default)("#" + me.props.Id).val(text.substr(0, text.length - 1));
                                }
                            }
                        } else {
                            if (text.length === 2 || text.length === 4 || text.length === 5) {
                                if (me.state.KeyCode) {
                                    if (me.state.KeyCode === 8) {
                                        (0, _jquery2.default)("#" + me.props.Id).val(text);
                                    } else {
                                        // eslint-disable-next-line default-case
                                        switch (text.length) {
                                            case 2:
                                                {
                                                    me.setDateText(me, text);
                                                    break;
                                                }
                                            case 4:
                                                {
                                                    var _prelast = text.substr(text.length - 2, 1);
                                                    var arr2 = _prelast.match(/[./]/gi);
                                                    if (!arr2) {
                                                        me.setDateText(me, text);
                                                    }
                                                    break;
                                                }
                                            case 5:
                                                {
                                                    var preprelast = text.substr(text.length - 3, 1);
                                                    var _arr = preprelast.match(/[./]/gi);
                                                    if (_arr) {
                                                        if (_arr.length > 0) {
                                                            me.setDateText(me, text);
                                                        }
                                                    }
                                                    break;
                                                }
                                            default:
                                                break;
                                        }
                                    }
                                }
                            }
                            if (text.length >= 3 && text.length <= 7) {
                                var _last = text.substring(text.length - 1, text.length);
                                var _prelast2 = text.substr(text.length - 2, 1);
                                if (_last === _prelast2 && (_last === "." || _last === "/")) {
                                    (0, _jquery2.default)("#" + me.props.Id).val(text.substr(0, text.length - 1));
                                }
                            }
                        }
                    } else {
                        (0, _jquery2.default)("#" + me.props.Id).val(text.substr(0, text.length - 1));
                    }
                } else {
                    (0, _jquery2.default)("#" + me.props.Id).val(text.substr(0, text.length - 1));
                }
            } else {
                (0, _jquery2.default)("#" + me.props.Id).val(text.substr(0, text.length - 1));
            }
        }
        //#endregion

        //#region Open Close Picker

    }, {
        key: 'ClosePicker',
        value: function ClosePicker(me) {
            if (document.getElementById(me.props.Id)) {
                if (me.state.PickerActive === true) {
                    me.setState({ PickerActive: false, IsValid: true }, function () {

                        if (document.getElementById('pickerContainer')) {
                            if (document.getElementById('pickerContainer').children.length === 0) {
                                _reactDom2.default.unmountComponentAtNode(document.getElementById('popupContainer'));
                            } else {
                                _reactDom2.default.unmountComponentAtNode(document.getElementById('pickerContainer'));
                            }
                        } else {
                            _reactDom2.default.unmountComponentAtNode(document.getElementById('popupContainer'));
                        }

                        (0, _jquery2.default)("#Content").css("opacity", "1");
                    });
                }
            } else {
                if (document.getElementById('pickerContainer').children.length === 0) {
                    _reactDom2.default.unmountComponentAtNode(document.getElementById('popupContainer'));
                } else {
                    _reactDom2.default.unmountComponentAtNode(document.getElementById('pickerContainer'));
                }
                (0, _jquery2.default)("#Content").css("opacity", "1");
            }
        }
    }, {
        key: 'OpenPicker',
        value: function OpenPicker(me) {
            var _this3 = this;

            if (me.state.PickerActive === false) {
                me.setState({ PickerActive: true }, function () {
                    var value = '';
                    if ((0, _jquery2.default)("#" + me.props.Id).val()) {
                        value = (0, _jquery2.default)("#" + me.props.Id).val();
                    } else if ((0, _jquery2.default)("#" + me.props.Id).attr("placeholder")) {
                        if (moment((0, _jquery2.default)("#" + me.props.Id).attr("placeholder"), ["DD-MM-YYYY", "MM-DD-YYYY"]).isValid() === true) {
                            value = (0, _jquery2.default)("#" + me.props.Id).attr("placeholder");
                        }
                    }

                    if (document.getElementById('popupContainer').children.length === 0) {
                        _reactDom2.default.render(_react2.default.createElement(_DatePicker2.default, {
                            AppURL: _this3.props.AppURL,
                            CalenderText: _this3.props.CalenderText,
                            CalenderWeekDayText: _this3.props.CalenderWeekDayText,
                            ChooseDataText: _this3.props.ChooseDataText,
                            Default: true,
                            DefaultVal: value,
                            First: me.props.First,
                            FirstLast: me.props.FirstLast,
                            Id: "dp" + me.props.Id,
                            Language: _this3.props.Language,
                            Last: me.props.Last,
                            MinValue: me.state.MinValue,
                            MaxValue: me.state.MaxValue,
                            reference: me,
                            ReferenceId: me.props.Id,
                            TooltipMonth: _this3.props.TooltipMonth,
                            TooltipYear: _this3.props.TooltipYear,
                            ShowDay: _this3.state.ShowDay,
                            MaxYearsInFuture: me.state.MaxYearsInFuture
                        }), document.getElementById('popupContainer'));
                    } else {
                        _reactDom2.default.render(_react2.default.createElement(_DatePicker2.default, {
                            AppURL: _this3.props.AppURL,
                            CalenderText: _this3.props.CalenderText,
                            CalenderWeekDayText: _this3.props.CalenderWeekDayText,
                            ChooseDataText: _this3.props.ChooseDataText,
                            Default: true,
                            DefaultVal: value,
                            FirstLast: me.props.FirstLast,
                            First: me.props.First,
                            Id: "dp" + me.props.Id,
                            Last: me.props.Last,
                            Language: _this3.props.Language,
                            MinValue: me.state.MinValue,
                            MaxValue: me.state.MaxValue,
                            reference: me,
                            ReferenceId: me.props.Id,
                            TooltipMonth: _this3.props.TooltipMonth,
                            TooltipYear: _this3.props.TooltipYear,
                            ShowDay: _this3.state.ShowDay,
                            MaxYearsInFuture: me.state.MaxYearsInFuture
                        }), document.getElementById('pickerContainer'));
                    }
                });
            }
        }
        //#endregion

    }, {
        key: 'checkIfClose',
        value: function checkIfClose(e) {
            this.validateDate(this, e);
            if (e.relatedTarget !== null) {
                if (_utilsLib.CheckValues.includes(e.relatedTarget.id, "dp")[0] === false) {
                    this.ClosePicker(this);
                }
            }
        }
    }, {
        key: 'focus',
        value: function focus(id) {
            if (this.state.Placeholder) {
                if (this.state.Placeholder.length > 0 && (0, _jquery2.default)("#" + id).val().length === 0) {
                    (0, _jquery2.default)("#" + id).val(this.state.Placeholder);
                }
            }

            var elements = document.getElementsByClassName('focusedCheckBox');
            var i = void 0;

            for (i = 0; i < elements.length; i++) {
                elements[i].classList.remove('focusedCheckBox');
            }

            elements = document.getElementsByClassName('extendedButton');
            i = void 0;

            for (i = 0; i < elements.length; i++) {
                elements[i].classList.remove('focusedButton');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var Tooltip = "";
            if (this.props.Tooltip && this.props.Tooltip !== "") {
                Tooltip = _react2.default.createElement(
                    'span',
                    { id: this.props.Id + "Tooltip" },
                    this.props.Tooltip
                );
            }

            var FieldNotFilled = "";
            if (this.props.FieldNotFilledHint && this.props.FieldNotFilledHint !== "") {
                FieldNotFilled = _react2.default.createElement(
                    'div',
                    { id: this.props.Id + "FieldNotFilled", className: "fieldNotFilled" },
                    this.props.FieldNotFilledHint
                );
            }

            var Style = null;
            if (this.props.Width) {
                var w = this.props.Width - 30; //eingegebene Breite- (Größe des Icons- Padding des Icons)
                Style = { width: w, float: this.props.Float };
            }

            var controlClassName = '';
            var readonly = false;
            var isTextFieldFilled = true;
            if (this.props.Editable) {
                if (!this.state.IsValid) {
                    if (this.state.isrequired) {
                        controlClassName = "datefieldNotFilled";
                        isTextFieldFilled = false;
                    } else {
                        controlClassName = "datefield";
                    }
                } else {
                    controlClassName = "datefield";
                }
            } else {
                controlClassName = "datefieldDisabled";
                readonly = true;
            }

            var placeholder = '';
            if (this.state.ShowDay === true) {
                switch (localStorage.getItem('vas_language')) {
                    case 'de':
                        {
                            placeholder = 'tt.mm.jjjj';
                            break;
                        }
                    case 'en':
                        {
                            placeholder = 'mm/dd/yyyy';
                            break;
                        }
                    default:
                        break;
                }
            } else if (this.state.ShowDay === false) {
                switch (localStorage.getItem('vas_language')) {
                    case 'de':
                        {
                            placeholder = 'mm.jjjj';
                            break;
                        }
                    case 'en':
                        {
                            placeholder = 'mm/yyyy';
                            break;
                        }
                    default:
                        break;
                }
            }

            if (this.state.Placeholder) {
                placeholder = this.state.Placeholder;
            }

            var isTextFieldFilledStyle = { visibility: 'hidden' };

            if (!isTextFieldFilled) {
                isTextFieldFilledStyle = { visibility: 'visible' };
            }

            return _react2.default.createElement(
                'div',
                { style: { width: this.props.Width, float: this.props.Float }, className: "df" },
                _react2.default.createElement(
                    'label',
                    { id: "datefieldLabel" + this.props.Id, className: 'datefieldLabel', 'for': this.props.Id, style: { float: this.props.Float } },
                    this.state.Label,
                    Tooltip,
                    ' '
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('input', {
                        autoComplete: 'off',
                        className: controlClassName,
                        id: this.props.Id,
                        onBlur: function onBlur(e) {
                            if (_this4.props.OnBlur) {
                                _this4.props.OnBlur();
                            }_this4.checkFields(_this4);_this4.checkIfClose(e);
                        }
                        //onClick={()=>{console.log("click");if (!readonly) {this.OpenPicker(this);} }}
                        , onChange: function onChange(e) {
                            _this4.ongoingText(_this4);if (_this4.props.OnChange) {
                                _this4.props.OnChange();
                            }
                        },
                        onKeyDown: function onKeyDown(e) {
                            if (e.keyCode === 9) {
                                e.preventDefault();
                            }_this4.tab(e, _this4);
                        },
                        onFocus: function onFocus() {
                            _this4.focus(_this4.props.Id);
                        },
                        placeholder: placeholder,
                        readOnly: readonly,
                        style: Style,
                        type: 'text',
                        value: this.state.Value
                    }),
                    _react2.default.createElement(
                        'div',
                        { className: 'IconDateRange' },
                        _react2.default.createElement(_Icon2.default, {
                            Align: "left",
                            AppURL: this.props.AppURL,
                            Color: "black",
                            Name: "Kalender",
                            OnClick: function OnClick() {
                                if (!readonly) {
                                    document.getElementById(_this4.props.Id).parentNode.childNodes[0].focus();_this4.OpenPicker(_this4);
                                }
                            },
                            Size: 24,
                            For: this.props.Id
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { id: this.props.Id + "FieldNotFilled", style: isTextFieldFilledStyle },
                    FieldNotFilled
                )
            );
        }
    }]);

    return DateField;
}(_react.Component);

exports.default = DateField;